module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.de186d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/bgi-dialog.png
// module id = bcPw
// module chunks = 0